import {
  buildClientCommandRoute,
  CLIENT_COMMAND_SCOPE_TYPES,
  isClientCommandIdentifier,
} from './clientCommandScreenRegistry';

export const CLIENT_COMMAND_NAVIGATION_TARGET_KEY = 'Client Command';

export const createSelectedClientCommandNavigationItems = ({
  screens,
  clientId,
  appId,
}) => {
  if (!Array.isArray(screens) || !isClientCommandIdentifier(clientId)) {
    return [];
  }

  return screens
    .filter((screen) => (
      screen?.CanAccess === true
      && screen.CanViewOnNav === true
      && screen.ScopeType !== CLIENT_COMMAND_SCOPE_TYPES.GLOBAL
    ))
    .map((screen) => {
      const routePath = buildClientCommandRoute(screen, { clientId, appId });
      if (!routePath) return null;

      return {
        _id: `client-command-${clientId}-${screen.Key}`,
        Key: `client-command-${clientId}-${screen.Key}`,
        ScreenKey: screen.Key,
        DisplayName: screen.DisplayName,
        RoutePath: routePath,
        ActiveRoutePaths: [routePath],
        Sequence: screen.Order,
        Placement: 'child',
        SubNavigations: [],
      };
    })
    .filter(Boolean);
};
